module.exports = __webpack_public_path__ + "img/feature-02-zh.7cfe3bf2.png";